



































































































import { Vue, Component, Prop, Model } from 'vue-property-decorator';

/**
 * Controlled form toggle button
 *
 * @event change `(checked: boolean, event: MouseEvent)`
 */
@Component
export default class SwSecurityCenterToggle extends Vue {
  // props
  @Prop({ default: false })
  @Model('change')
  value: boolean;

  @Prop({ required: true })
  name: string;

  @Prop({ default: true })
  submitable: boolean;

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  // data
  cssPrefix: string = 'sw-security-center-toggle';

  get isOff(): boolean {
    return (!this.value);
  }

  get submitValue(): string {
    return this.isOff ? '0' : '1';
  }

  // methods
  handleToggle(event:Event) {
    if (this.disabled) { return; }
    this.$emit('change', !this.value, event);
  }
}
